<template>
  <footer class="d-footer">
    <div class="footer-wrapper">
      <div class="w">
        <div class="footer-wrapper-box">
          <div class="footer_right">
            <div class="phone-con">
              <div class="title">
                <i
                  v-if="deviceType == 'pc'"
                  class="iconfont icon-dianhua4 ico"
                ></i
                >全国服务电话
              </div>
              <img
                src="../../assets/images/phone.png"
                v-if="deviceType != 'pc'"
                alt=""
              />
              <div class="phone">400-888-6369</div>
            </div>
            <div class="footer_select">
              <span>友情链接</span>
              <div class="select-box">
                <select
                  name="select"
                  @change="onChange"
                  v-model="value"
                  style="
                    background-color: #fff;
                    color: #666666;
                    border-radius: 4px;
                  "
                  :style="{
                    backgroundColor: deviceType == 'pc' ? '#fff' : '#E7EDF0',
                  }"
                >
                  <option
                    v-for="(item, i) in linkList"
                    :key="i"
                    :value="item.id"
                  >
                    {{ item.title }}
                  </option>
                </select>
                <div class="arrow"></div>
              </div>
            </div>
          </div>
          <div class="footer_left">
            <dl class="footer_house">
              <dt>关于鼎欣</dt>
              <dd><a @click="openLink('/about')">了解鼎欣</a></dd>
              <dd><a @click="openLink('/about?type=1')">社会责任</a></dd>
              <dd>
                <a @click="openLink('/talent/corporateCulture')">加入鼎欣</a>
              </dd>
              <dd><a @click="openLink('/support/cloud')">产品体验馆</a></dd>
            </dl>
            <dl>
              <dt>资讯&amp;活动</dt>
              <dd><a @click="openLink('/news')">最新活动</a></dd>
              <dd><a @click="openLink('/news')">资讯发布</a></dd>
              <dd><a @click="openLink('/news')">媒体报道</a></dd>
              <dd><a @click="openLink('/news')">社交媒体</a></dd>
            </dl>
            <dl>
              <dt>案例&amp;资料</dt>
              <dd><a @click="openLink('/case')">案例中心</a></dd>
              <dd><a @click="openLink('/product')">解决方案</a></dd>
              <dd><a @click="openLink('/product')">资料库</a></dd>
              <dd><a @click="openLink('/product')">产品白皮书</a></dd>
            </dl>
            <dl>
              <dt>服务支持</dt>
              <!-- <dd><a @click="openLink('/support/page')">E-HR云应用平台（教育版）</a></dd> -->
              <dd><a @click="openLink('/support/cloud')">云市场</a></dd>
              <dd>
                <a @click="openLink('/support/service?type=1')">加入合作伙伴</a>
              </dd>
              <dd>
                <a @click="openLink('/support/page')">服务支持</a>
              </dd>
              <dd>
                <a @click="openLink('/support/service?type=1')">方案咨询</a>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <div class="footer2">
      <div class="w df jcsb">
        <div class="footer_text">
          <span class="pull-right" v-if="deviceType == 'pc'"
            ><span>网站地图</span> <span class="pull-right-line">|</span>
            <span>使用条款</span> <span class="pull-right-line">|</span
            ><span>隐私条约</span>
            <span class="pull-right-time">©2007-{{ year }}</span>
            <span>鼎欣科技股份有限公司</span>
            <span class="pull-right-copyright">版权所有</span
            ><a href="https://beian.miit.gov.cn/" target="_blank"
              >赣ICP备14004626号
            </a></span
          >
          <div v-else class="pull-viv">
            <div class="pull-text">
              <span>网站地图</span>
              <span>|</span>
              <span>使用条款</span>
              <span>|</span>
              <span>隐私条约</span>
            </div>
            <div class="pull-ts">
              <span> ©2007-{{ year }} 鼎欣科技股份有限公司 </span>
              <span class="pull-bh">版权所有</span>
              <span class="pull-dz">
                <a href="https://beian.miit.gov.cn/" target="_blank"
                  >赣ICP备14004626号
                </a></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import dLogo from './d-logo'
import moment from 'moment'
export default {
  components: { dLogo },
  computed: {
    deviceType() {
      return this.$store.state.app.deviceType
    },
  },
  mounted() {
    this.initYear()
  },
  methods: {
    openLink(path) {
      this.$router.push({ path })
    },
    onChange(e) {
      this.linkList.forEach((item) => {
        if (item.id == this.value) {
          window.open(item.url, '_blank')
        }
      })
    },
    initYear() {
      const now = moment()
      this.year = now.format('YYYY')
    },
  },
  data() {
    return {
      year: '',
      value: '6',
      linkList: [
        {
          id: '1',
          title: '财政部',
          url: 'http://www.mof.gov.cn/',
        },
        {
          id: '2',
          title: '中国人民银行',
          url: 'http://www.pbc.gov.cn/',
        },
        {
          id: '3',
          title: '人力资源与社会保障部',
          url: 'http://www.mohrss.gov.cn/',
        },
        {
          id: '4',
          title: '科学技术部',
          url: 'http://www.most.gov.cn',
        },
        {
          id: '5',
          title: '工业和信息化部',
          url: 'https://www.miit.gov.cn/',
        },
        {
          id: '6',
          title: '江西省人民政府',
          url: 'http://www.jiangxi.gov.cn/',
        },
        {
          id: '7',
          title: '江西省人力资源和社会保障厅',
          url: 'http://rst.jiangxi.gov.cn',
        },
        {
          id: '8',
          title: '青海省人力资源和社会保障厅',
          url: 'http://rst.qinghai.gov.cn/',
        },
        {
          id: '9',
          title: '西藏自治区人力资源和社会保障厅',
          url: 'http://hrss.xizang.gov.cn/',
        },
        {
          id: '10',
          title: '湖南省人力资源和社会保障厅',
          url: 'http://rst.hunan.gov.cn/',
        },
        {
          id: '11',
          title: '海南省人力资源和社会保障厅',
          url: 'http://hrss.hainan.gov.cn/',
        },
        {
          id: '12',
          title: '广西壮族自治区人力资源和社会保障厅',
          url: 'http://rst.gxzf.gov.cn/',
        },
        {
          id: '13',
          title: '山西省人力资源和社会保障厅',
          url: 'http://rst.shanxi.gov.cn/',
        },
        {
          id: '14',
          title: '云南省人力资源和社会保障厅',
          url: 'http://hrss.yn.gov.cn/',
        },
        {
          id: '15',
          title: '浙江省人力资源和社会保障厅',
          url: 'http://rlsbt.zj.gov.cn/',
        },
        {
          id: '16',
          title: '江苏省人力资源和社会保障厅',
          url: 'http://jsrlzyshbz.jiangsu.gov.cn/',
        },
        {
          id: '17',
          title: '江西省科学技术厅',
          url: 'http://kjt.jiangxi.gov.cn/',
        },
        {
          id: '18',
          title: '江西省工业和信息化厅',
          url: 'http://www.jxciit.gov.cn/',
        },
        {
          id: '19',
          title: '江西电信',
          url: 'http://www.189.cn/jx/',
        },
        {
          id: '20',
          title: '中国移动',
          url: 'http://10086.cn/index_5074.html',
        },
        {
          id: '21',
          title: '南昌市高新技术产业开发区',
          url: 'http://nchdz.nc.gov.cn/',
        },
        {
          id: '22',
          title: '南昌市经济技术开发区',
          url: 'http://ncjk.nc.gov.cn',
        },
      ],
    }
  },
}
</script>